import { useContext, useMemo, useState } from 'react'

import { useSelector } from 'react-redux'
import { TreeSelect } from 'antd'

import SearchCheckbox from '../../../../Components/antd/Selects/SearchCheckbox'
import InstitutionSchoolsList from '../../Quotas/SchoolQuotasView/InstitutionSchoolsList'
import InstitutionSectionsList from '../../Quotas/SchoolQuotasView/InstitutionSectionsList'
import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import { calc, pc, px } from '../../../../utils/cssHelper'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { getIdOrNull } from '../../../../utils'
import { getHospitalDepartments } from '../../../../utils/api/hospitalDepartment'
import useRequest from '../../../../hooks/useRequest'
import Loading from '../../../../Components/shared/Loading'

const PADDING = 12

const Prefixes = Object.freeze({
  DEPARTMENT: 'D_',
  SECTOR: 'S_'
})

const Settings = ({ isHostpitalDepartmentViewToggled, schools, selectedSections, onSelectEntity, onSelectSchools, onSelectSections }) => {
  const { sectors, loading: areSectorLoading } = useContext(InstitutionContext)

  const t = useSelector(selectTranslate)

  const [selected, setSelected] = useState([])
  const hospitalDepartments = useRequest({
    request: getHospitalDepartments,
    parameters: useMemo(() => ({ paginate: false }), [])
  })

  const checkbox = useMemo(() => {
    let title
    let items
    let isLoading
    let onSelection

    if (isHostpitalDepartmentViewToggled) {
      title = 'common.hospital_departments'
      items = hospitalDepartments.data.flatMap(dept => dept.sectors.map(s => ({ ...s, deptName: dept.name })))
      isLoading = hospitalDepartments.loading
    } else {
      title = 'common.sectors'
      items = sectors
      isLoading = areSectorLoading
    }

    return { checkboxTitle: title, items, isLoading, onSelection }
  }, [areSectorLoading, hospitalDepartments.data, hospitalDepartments.loading, isHostpitalDepartmentViewToggled, sectors])

  const handleSelect = truc => {
    const filtered = truc.filter(t => !t.startsWith(Prefixes.DEPARTMENT))
    setSelected(filtered)

    onSelectEntity(filtered
      .map(f => getIdOrNull(f.split(Prefixes.SECTOR)[1]))
      .map(f => checkbox.items.find(i => getIdOrNull(i) === f))
    )
  }

  return (
    <div
      className={'settings h-100 pd-' + PADDING}
      style={{ display: 'flex', flexDirection: 'column', gap: px(PADDING * (isHostpitalDepartmentViewToggled ? 3 : 1)), height: '100%' }}
    >
      {!isHostpitalDepartmentViewToggled && (
        <div style={{ flex: '0 0 22%', minHeight: px(200), display: 'flex' }}>
          <SearchCheckbox
            checkAllOption
            items={checkbox.items}
            labelKey='name'
            loading={checkbox.isLoading}
            tooltipKey='name'
            title={t(checkbox.checkboxTitle)}
            valueKey='id'
            style={{ height: '100%', margin: '0px' }}
            onCheck={onSelectEntity}
            onCheckAll={onSelectEntity}
          />
        </div>
      )}
      {isHostpitalDepartmentViewToggled && (
        <div className='w-100'>
          <h4><b>{t(checkbox.checkboxTitle)}</b></h4>
          <div>
            {checkbox.isLoading && (
              <Loading />
            )}
            {!checkbox.isLoading && (
              <TreeSelect
                className='w-100'
                value={selected}
                onChange={handleSelect}
                multiple
                treeCheckable
                dropdownStyle={{ maxHeight: px(400), overflowY: 'auto' }}
                dropdownClassName='ant-tree-select-padding'
              >
                {hospitalDepartments.data.map(dept => (
                  <TreeSelect.TreeNode
                    value={Prefixes.DEPARTMENT + dept.id}
                    key={Prefixes.DEPARTMENT + dept.id}
                    title={dept.name}
                    checkable={false}
                  >
                    {dept.sectors.map(s => (
                      <TreeSelect.TreeNode
                        value={Prefixes.SECTOR + s.id}
                        key={Prefixes.SECTOR + s.id}
                        title={s.name}
                      />
                    ))}
                  </TreeSelect.TreeNode>
                ))}
              </TreeSelect>
            )}
          </div>
        </div>
      )}
      {isHostpitalDepartmentViewToggled && (
        <div style={{ flex: '1 1 50%', minHeight: px(260), overflow: 'hidden' }}>
          <InstitutionSectionsList selected={selectedSections} onSelect={onSelectSections} />
        </div>
      )}
      {!isHostpitalDepartmentViewToggled && (
        <div className='mt-16' style={{ height: calc(pc(70), '-', px(PADDING * 5)) }}>
          <InstitutionSchoolsList selected={schools.map(getIdOrNull)} onSelect={onSelectSchools} />
        </div>
      )}
    </div>
  )
}

export default Settings
